import { SetupOrchestrator } from "../orchestrator.js"
import { createSetupHandlers } from "../steps/index.js"
import { SetupServices } from "../steps/runtime.js"
import { SetupContext, SetupState } from "./types.js"

export async function runSetupFlow(input: {
  initialContext: SetupContext
  initialState: SetupState
  log: (message: string) => void
  onStateTransition: (state: SetupState, context: SetupContext) => Promise<void> | void
  services: SetupServices
}): Promise<void> {
  const orchestrator = new SetupOrchestrator({
    handlers: createSetupHandlers(input.services),
    log: input.log,
    onStateTransition: input.onStateTransition,
  })

  await orchestrator.run(input.initialState, input.initialContext)
}
